export enum PropertyAssociationType {
    Owned = 'AB372ABD-ABAF-EC11-8CC9-000C290D53A0',
    Prospect = '5BBB84C8-ABAF-EC11-8CC9-000C290D53A0'
}

export enum PropertyType {
    'SFR-Detached' = 'Single Family',
    'Condominium' = 'Condominium',
    'SFR-Attached' = 'Townhouse',
    'Cooperative' = 'Co-op',
    'TwoToFourFamily' = 'Multi-family Home'
}

export const PPC_PROPERTY_TYPE_LIST = [
    'SFR-Detached',
    'Condominium',
    'SFR-Attached',
    'Cooperative',
    'TwoToFourFamily'
];

export enum PricingStatus {
    '2F88ED53-7F4E-ED11-ADE6-000D3A32B31E' = 'Pricing Info Needed - Client and Property',
    '3088ED53-7F4E-ED11-ADE6-000D3A32B31E' = 'Ready for Pricing',
    '3188ED53-7F4E-ED11-ADE6-000D3A32B31E' = 'Products Selected',
    '3FA924AA-2A9C-ED11-994A-000D3A5BB313' = 'Pricing Info Needed - Property',
    '40A924AA-2A9C-ED11-994A-000D3A5BB313' = 'Pricing Info Needed - Client'
}

export enum PricingStatusId {
    PricingInfoNeededClientandProperty = '2F88ED53-7F4E-ED11-ADE6-000D3A32B31E',
    ReadyForPricing = '3088ED53-7F4E-ED11-ADE6-000D3A32B31E',
    ProductsSelected = '3188ED53-7F4E-ED11-ADE6-000D3A32B31E',
    PricingInfoNeededProperty = '3FA924AA-2A9C-ED11-994A-000D3A5BB313',
    PricingInfoNeededClient = '40A924AA-2A9C-ED11-994A-000D3A5BB313'
}


export enum PricingStatusName {
    PricingInfoNeededClientandProperty = 'Pricing Info Needed - Client and Property',
    ReadyForPricing = 'Ready for Pricing',
    ProductsSelected = 'Products Selected',
    PricingInfoNeededProperty = 'Pricing Info Needed - Property',
    PricingInfoNeededClient = 'Pricing Info Needed - Client'
}

export enum PropertyAssociationTypeId {
    'Owned' = 'AB372ABD-ABAF-EC11-8CC9-000C290D53A0',
    'Prospect' = '5BBB84C8-ABAF-EC11-8CC9-000C290D53A0'
}
